function initStyxie() {
  if (window.Styxie && window.Styxie.deferredInit) {
    window.Styxie.deferredInit()
  }
}

if (typeof Turbolinks !== 'undefined') {
  $(document).on('turbolinks:load', initStyxie)
} else {
  $(initStyxie)
}
